import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

interface Props {
  variant?: 'normal' | 'handsfree';
}

export default function ProjectUsabilityResponseSubmitted({
  variant = 'normal',
}: Props) {
  const t = useTranslations('Usability');

  if (variant === 'handsfree') {
    return (
      <div
        className='flex h-full flex-1 items-center justify-center'
        data-test='usability-submitted-screen'
      >
        <div className='w-full max-w-sm rounded-2xl bg-white px-8 py-6 shadow-md'>
          <h2 className='text-base font-bold text-gray-900'>
            {t('submitted')}
          </h2>
          <p className='mt-1 text-sm text-gray-600'>
            {t('thankYouForFeedback')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className='flex h-full flex-1 flex-col items-center justify-center gap-3'
      data-test='usability-submitted-screen'
    >
      <FontAwesomeIcon
        icon={faPaperPlane}
        className='text-gray-400'
        size='2x'
      />
      <div className='text-center'>
        <h2 className='text-base font-bold text-gray-900'>{t('submitted')}</h2>
        <p className='mt-1 text-sm text-gray-600'>{t('thankYouForFeedback')}</p>
      </div>
    </div>
  );
}
